/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import NotificationListItem from "./NotificationListItem";

class NotificationList extends React.Component {
    static propTypes = {
        notifications: PropTypes.array,
        currentTime: PropTypes.object
    };

    static defaultProps = {
        currentTime: new Date()
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderNotifications() {
        let result = [];
        let i = 0;
        for (let n of this.props.notifications) {
            if (i++ !== 0) {
                result.push((<li key={i} className="divider"></li>));
                i++;
            }
            result.push((<NotificationListItem key={i} currentTime={this.props.currentTime} {...n} />));
        }
        return result;
    }

    render() {
        return (
            <ul className="dropdown-menu dropdown-alerts">
                {this.renderNotifications()}
            </ul>
        );
    }
}

export default NotificationList;
